var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3342 16H15.001C15.3968 16 15.7614 15.7857 15.9594 15.4321L19.8485 8.575C20.0499 8.22143 20.0499 7.78571 19.852 7.42857C19.6541 7.07143 19.2894 6.85714 18.8901 6.85714H5.00032C4.60447 6.85714 4.23986 7.07143 4.04193 7.425L1.66677 11.6107V2.28571C1.66677 1.97143 1.91679 1.71429 2.22237 1.71429H6.30249C6.44834 1.71429 6.59071 1.775 6.69488 1.88214L7.61508 2.82857C8.34429 3.57857 9.33394 4 10.3653 4H14.4454C14.751 4 15.001 4.25714 15.001 4.57143V5.71429H16.6677V4.57143C16.6677 3.31071 15.6712 2.28571 14.4454 2.28571H10.3653C9.77494 2.28571 9.20893 2.04643 8.79224 1.61786L7.87204 0.667857C7.45535 0.239286 6.88934 0 6.29902 0H2.22237C0.996593 0 0 1.025 0 2.28571V13.7143C0 14.975 0.996593 16 2.22237 16H3.04534H13.3342Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.6a1cab6ccf61cd93488c166a07ecdbe8.svg";
export { ForwardRef as ReactComponent };